<script setup>
import {onMounted, defineEmits, ref, defineProps, defineExpose} from 'vue'

// Props & emits
let emit = defineEmits(['changed'])

const props = defineProps({
  activeRequestFields: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const defaultFormData = {
  advertiser_name: '',
  advertiser_id: null,
  geo: '',
  registration_country: '',
  ads_running_context: '',
  expected_spend: '',
  campaign_duration: '',
  example_titles: '',
  landing_page_language: '',
  comment: '',
}
let formData = ref(cloneSafe(defaultFormData))

// Methods
onMounted(() => {
  init()
})

const init = () => {
  if (props.activeRequestFields) {
    formData.value = Object.assign(formData.value, props.activeRequestFields)
  }
}

const resetForm = () => {
  formData.value = cloneSafe(defaultFormData)
}

const onChange = () => {
  emit('changed', {fields: formData.value})
}

defineExpose({resetForm})
</script>

<template>
  <div class="form-group">
    <label for="tiktok-crypto-wl-advertiser_name">Advertiser Name *</label>
    <div class="input-group">
      <input
        v-model="formData.advertiser_name"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-advertiser_name"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-advertiser_id">Advertiser ID *</label>
    <div class="input-group">
      <input
        v-model="formData.advertiser_id"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-advertiser_id"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-geo">Target Geo *</label>
    <div class="input-group">
      <input
        v-model="formData.geo"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-geo"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-registration_country"
      >Registration Country <small class="text-muted">(if applicable)</small>
    </label>
    <div class="input-group">
      <input
        v-model="formData.registration_country"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-registration_country"
        type="text"
        :disabled="disabled"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-expected_spend">How much will this advertiser spend in the next 3-6 months?</label>
    <div class="input-group">
      <input
        v-model="formData.expected_spend"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-expected_spend"
        type="text"
        :disabled="disabled"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-ads_running_context">
      Has the advertiser been running ads in the target country? * <br />
      <small class="text-muted">(provide context)</small>
    </label>
    <div class="input-group">
      <input
        v-model="formData.ads_running_context"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-ads_running_context"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-campaign_duration">Campaign Duration * </label>
    <div class="input-group">
      <input
        v-model="formData.campaign_duration"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-campaign_duration"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-example_titles">Example Titles * </label>
    <div class="input-group">
      <textarea
        v-model="formData.example_titles"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-example_titles"
        :disabled="disabled"
        rows="3"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-landing_page_language">Language of Landing Page - US * </label>
    <div class="input-group">
      <input
        v-model="formData.landing_page_language"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-landing_page_language"
        :disabled="disabled"
        type="text"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="tiktok-crypto-wl-comment">Any Comments That You Would Like to Add</label>
    <div class="input-group">
      <textarea
        v-model="formData.comment"
        @change="onChange"
        class="form-control"
        id="tiktok-crypto-wl-comment"
        :disabled="disabled"
        rows="3"
      />
    </div>
  </div>
</template>
